module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-segment-js/gatsby-browser.js'),
      options: {"plugins":[],"prodKey":"z049ebV22kBiDNbJvfCx8tPDCPR9Bim5","devKey":"nU9Ysr5qZSgnI8sdVWH6HruPERGrtkUW","trackPage":false,"delayLoad":true},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
